import { Button, Select } from "antd";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Table from "../../../core/common/dataTable/index";
import { getHolidaysList } from "../../../core/data/redux/holidaysSlice";
import { DateFormat } from "../../../core/hooks/dateFormat";
import { all_routes } from "../../router/all_routes";
import PermissionGuard from "../../permissionGuard";

const HolidaysCalendar = () => {
  const routes = all_routes;
  const dispatch = useDispatch();
  const holidaysState = useSelector((state: any) => state.holidaysState);

  const [dataList, setDataList] = useState<any[]>([]);
  const [query, setQuery] = useState<string>("");
  const [holidayCalID, setHolidayCalID] = useState<string | undefined>(undefined);
  const [holidayType, setHolidayType] = useState<string | undefined>(undefined);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 10,
  });

  const fetchRecords = (pagination: any, query: string, holidayCalID?: string,holidayType?:string) => {
    dispatch(
      getHolidaysList({
        page: pagination.current,
        limit: pagination.pageSize,
        query,
        holidayCalID, // Pass filter to API
        keyword: holidayType,
      })
    );
  };

  const handlePagination = (pagination: any) => {
    setPagination({
      current: pagination.page,
      pageSize: pagination.pageSize,
      total: pagination.total || 10,
    });
    fetchRecords(pagination, query, holidayCalID,holidayType);
  };

  const handleSearch = (query: string) => {
    fetchRecords(pagination, query, holidayCalID,holidayType);
  };

  const handleHolidayCalIDChange = (value: string) => {
    setHolidayCalID(value);
    setPagination({ ...pagination, current: 1 }); // Reset to first page
    fetchRecords({ ...pagination, current: 1 }, query, value, holidayType);
  };

  const handleHolidayTypeChange = (value: string) => {
    setHolidayType(value);
    setPagination({ ...pagination, current: 1 }); // Reset to first page
    fetchRecords({ ...pagination, current: 1 }, query, holidayCalID, value);
  };

  

  useEffect(() => {
    fetchRecords(pagination, query, holidayCalID,holidayType);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (holidaysState.loading === "fulfilled") {
      const result = holidaysState.holidays?.data || {};
      setDataList(result?.data || []);
      setPagination({
        ...pagination,
        total: result.total,
        current: result.page || 1,
        pageSize: result.limit || 10,
      });
    }
    // eslint-disable-next-line
  }, [holidaysState]);

  const columns = [
    {
      title: "Sr. No.",
      dataIndex: "id",
      render: (text: string, record: any, index: number) => (
        <>
          <div>
            {pagination.current
              ? index + pagination.current * pagination.pageSize - pagination.pageSize + 1
              : index + 1}
          </div>
        </>
      ),
      sorter: (a: any, b: any) => a.id - b.id,
    },
    {
      title: "Holiday Cal ID",
      dataIndex: "holidayCalID",
      render: (text: string) => text || "",
    },
    {
      title: "Holiday Name",
      dataIndex: "txtLong",
      render: (text: string) => text || "",
    },
    {
      title: "Date",
      dataIndex: "date",
      render: (date: any) => date,
    },
  ];

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
          <div className="my-auto mb-2">
            <h3 className="page-title mb-1">Holidays (Calendar)</h3>
            <nav>
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <Link to={routes.adminDashboard}>Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="#">Administration</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Holidays (Calendar)
                </li>
              </ol>
            </nav>
          </div>
          <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
            <PermissionGuard route="holidays/add">
              <Button
                type="primary"
                //   onClick={handleAdd}
                className="d-flex align-items-center mb-2"
                style={{ backgroundColor: "red" }}
              >
                <i className="ti ti-square-rounded-plus me-2" />
                Add Holiday
              </Button>
            </PermissionGuard>
          </div>
        </div>
        <div className="card">
          <div className="card-header d-flex align-items-center justify-content-between flex-wrap pb-0">
            <h4 className="mb-4 mt-3">Holiday List</h4>
            <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
              <Select
                allowClear
                style={{ width: 180 }}
                placeholder="Filter by Holiday"
                value={holidayType}
                onChange={handleHolidayTypeChange}
              >
                <Select.Option value="">All</Select.Option>
                <Select.Option value="GH">GH</Select.Option>
                <Select.Option value="RH">RH</Select.Option>
              </Select>

              <Select
                allowClear
                style={{ width: 180 }}
                placeholder="Filter by Holiday Cal ID"
                value={holidayCalID}
                onChange={handleHolidayCalIDChange}
              >
                <Select.Option value="">All</Select.Option>
                <Select.Option value="MB">MB</Select.Option>
                <Select.Option value="PN">PN</Select.Option>
                <Select.Option value="MM">MM</Select.Option>
                <Select.Option value="DM">DM</Select.Option>
                <Select.Option value="SR">SR</Select.Option>
                <Select.Option value="BH">BH</Select.Option>
              </Select>
            </div>
          </div>

          <div className="card-body p-0 py-3">
            <Table
              columns={columns}
              dataSource={dataList}
              Selection={false}
              paginationConfig={pagination}
              handlePagination={handlePagination}
              loading={holidaysState.loading === "pending"}
              handleSearch={handleSearch}
            />
          </div>
        </div>
      </div>
    </div >
  );
};

export default HolidaysCalendar;
